var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrvtoShower(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.625 22.3125C6.14277 22.3125 6.5625 21.8928 6.5625 21.375C6.5625 20.8572 6.14277 20.4375 5.625 20.4375C5.10723 20.4375 4.6875 20.8572 4.6875 21.375C4.6875 21.8928 5.10723 22.3125 5.625 22.3125Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 19.6875C8.76777 19.6875 9.1875 19.2678 9.1875 18.75C9.1875 18.2322 8.76777 17.8125 8.25 17.8125C7.73223 17.8125 7.3125 18.2322 7.3125 18.75C7.3125 19.2678 7.73223 19.6875 8.25 19.6875Z",
    fill: "#292D32"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.625 19.3125C3.14277 19.3125 3.5625 18.8928 3.5625 18.375C3.5625 17.8572 3.14277 17.4375 2.625 17.4375C2.10723 17.4375 1.6875 17.8572 1.6875 18.375C1.6875 18.8928 2.10723 19.3125 2.625 19.3125Z",
    fill: "#292D32"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 16.6875C5.76777 16.6875 6.1875 16.2678 6.1875 15.75C6.1875 15.2322 5.76777 14.8125 5.25 14.8125C4.73223 14.8125 4.3125 15.2322 4.3125 15.75C4.3125 16.2678 4.73223 16.6875 5.25 16.6875Z",
    fill: "#292D32"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2498 3.75H20.5592C20.4618 3.74966 20.3653 3.76853 20.2752 3.80553C20.1851 3.84253 20.1032 3.89694 20.0342 3.96563L17.2498 6.75M17.2498 6.75L5.18421 8.75625C5.04762 8.77886 4.91995 8.83882 4.81534 8.92952C4.71073 9.02021 4.63327 9.13809 4.59153 9.27009C4.5498 9.4021 4.54541 9.54308 4.57887 9.67743C4.61232 9.81177 4.68231 9.93424 4.78108 10.0313L13.9686 19.2188C14.0656 19.3175 14.1881 19.3875 14.3224 19.421C14.4568 19.4544 14.5977 19.45 14.7297 19.4083C14.8618 19.3666 14.9796 19.2891 15.0703 19.1845C15.161 19.0799 15.221 18.9522 15.2436 18.8156L17.2498 6.75Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrvtoShower);
export default __webpack_public_path__ + "static/media/trvto_Shower.178e5b455b2f717ae4b007d2bcc6baa7.svg";
export { ForwardRef as ReactComponent };